export default {
  // Navbar
  "nav.home": "Home",
  "nav.shoppingGuide": "Shopping Guide",
  "nav.spreadsheet": "CSSBuy Spreadsheet",
  "nav.categories": "Categories",
  "nav.guides": "Guides",
  "nav.qc": "QC",
  "nav.shipping": "Shipping",
  "nav.comparisons": "Comparisons",
  "nav.safety": "Safety",
  "nav.language": "Language",
  "nav.search": "Search",
  "nav.cta": "Explore Spreadsheet",

  // Hero
  "hero.eyebrow": "CSSBUY GUIDE • SPREADSHEET • SHOPPING",
  "hero.h1": "CSSBuy Spreadsheet: find products, sellers & buying guides",
  "hero.description": "Explore the CSSBuy Spreadsheet, discover products and sellers, compare options and learn how to evaluate QC, warehousing, shipping and important information before making a purchase.",
  "hero.cta.primary": "Explore CSSBuy Spreadsheet",
  "hero.cta.secondary": "View Buying Guides",
  "hero.trust": "Informative content • Updated guides • Transparent comparisons",

  // Search
  "search.h2": "Find quickly on CSSBuy Spreadsheet",
  "search.placeholder": "Search products, categories or sellers...",
  "search.filters": "Category / Product / Seller / QC / Popularity / Latest",
  "search.button": "Search",

  // Benefits
  "benefits.h2": "Everything you need to understand CSSBuy Spreadsheet",
  "benefits.findProducts": "Find Products",
  "benefits.findProductsDesc": "Discover how to search for products and organize relevant information.",
  "benefits.compareSellers": "Compare Sellers",
  "benefits.compareSellersDesc": "Learn which factors to analyze before choosing a seller.",
  "benefits.checkQC": "Check QC",
  "benefits.checkQCDesc": "Understand how to interpret quality control photos.",
  "benefits.understandShipping": "Understand Shipping",
  "benefits.understandShippingDesc": "Learn the key factors that influence shipping costs and methods.",

  // Spreadsheet Hub
  "spreadsheet.h2": "CSSBuy Spreadsheet",
  "spreadsheet.text": "Our CSSBuy Spreadsheet hub organizes resources by category to make it easy to research products, sellers and guides.",
  "spreadsheet.cta": "Explore Spreadsheet",

  // Categories
  "categories.h2": "Popular Categories",
  "categories.viewAll": "View all categories",
  "categories.shoes": "Sneakers",
  "categories.hoodies": "Streetwear",
  "categories.tshirts": "T-Shirts",
  "categories.sweaters": "Hoodies",
  "categories.jackets": "Jackets",
  "categories.pants": "Pants",
  "categories.bags": "Bags",
  "categories.accessories": "Accessories",
  "categories.sportswear": "Sportswear",

  // How It Works
  "howItWorks.h2": "How to use a CSSBuy Spreadsheet?",
  "howItWorks.step1": "Search",
  "howItWorks.step1Desc": "Find products, categories or sellers.",
  "howItWorks.step2": "Analyze",
  "howItWorks.step2Desc": "Check available information and data.",
  "howItWorks.step3": "Compare",
  "howItWorks.step3Desc": "Evaluate different options.",
  "howItWorks.step4": "Verify",
  "howItWorks.step4Desc": "Check QC, shipping, warehousing and safety.",
  "howItWorks.step5": "Continue",
  "howItWorks.step5Desc": "When appropriate, proceed to the main website.",

  // Guides
  "guides.h2": "Guides to shop with more knowledge",
  "guides.viewAll": "View all guides",
  "guides.review": "CSSBuy Review",
  "guides.shipping": "CSSBuy Shipping Cost",
  "guides.warehouse": "CSSBuy Warehouse",
  "guides.legit": "CSSBuy Legit",
  "guides.coupon": "CSSBuy Coupon",
  "guides.discount": "CSSBuy Discount Code",

  // Comparison
  "comparison.h2": "Compare before choosing",
  "comparison.viewAll": "View comparisons",

  // Safety
  "safety.h2": "Safety comes first",
  "safety.text": "Learn how to verify links, sellers, products, QC, payments and information before buying.",
  "safety.cta": "Open Safety Center",

  // Trust
  "trust.h2": "Transparent and independent content",
  "trust.text": "CSSBuyBR.INK is an independent resource created to organize information, guides and resources related to the CSSBuy Spreadsheet. We are not the official CSSBuy website, unless expressly and verifiably stated.",

  // Final CTA
  "finalCta.h2": "Ready to explore CSSBuy Spreadsheet?",
  "finalCta.text": "Find resources, compare information and choose the right guide for your next step.",
  "finalCta.primary": "Explore CSSBuy Spreadsheet",
  "finalCta.secondary": "Visit main website",

  // Category Dropdown
  "dropdown.title": "Product Categories",
  "dropdown.shoes": "Shoes",
  "dropdown.hoodies": "Hoodies/Sweaters",
  "dropdown.tshirts": "T-Shirts",
  "dropdown.jackets": "Jackets",
  "dropdown.pants": "Pants/Shorts",
  "dropdown.headwear": "Headwear",
  "dropdown.sets": "Sets",
  "dropdown.underwear": "Underwear/Underpants",
  "dropdown.jersey": "Jersey",
  "dropdown.accessories": "Accessories",
  "dropdown.bags": "Bags",
  "dropdown.belts": "Belts",
  "dropdown.perfumes": "Perfumes",
  "dropdown.other": "Other Stuff",

  // Buttons
  "button.cssbuySpreadsheet": "CSSBuy Spreadsheet",
  "button.buyItNow": "Buy It Now",

  // Footer
  "footer.about": "About",
  "footer.editorial": "Editorial Policy",
  "footer.contact": "Contact",
  "footer.privacy": "Privacy",
  "footer.terms": "Terms",
  "footer.disclaimer": "Disclaimer",
  "footer.disclaimerText": "CSSBuyBR.INK is an independent information resource. We are not the official CSSBuy website. Always verify important information from official sources before purchasing.",
  "footer.copyright": "© 2026 CSSBuyBR.INK — Independent CSSBuy Spreadsheet Resource",

  // Articles
  "articles.h2": "Articles & Guides",
  "articles.readMore": "Read full article",
  "articles.backToHome": "Back to homepage",
  "articles.relatedArticles": "Related articles",
  "articles.updated": "Updated",
  "articles.published": "Published",
  "articles.author": "Author",
  "articles.minRead": "min read",
  "articles.keyTopics": "Key topics",
  "articles.fullContentSoon": "The full content of this guide is being prepared. Check out a summary of what you will find below.",

  // Language Switcher
  "lang.pt": "Português",
  "lang.en": "English",
  "lang.de": "Deutsch",

  // NotFound
  "notFound.title": "Page not found",
  "notFound.description": "The page you are looking for does not exist or has been moved.",
  "notFound.backHome": "Back to homepage",
};